// extracted by mini-css-extract-plugin
export var legendIndicator = "_d8-1";
export var legendRight = "_d8-0";